import React from "react";
import { Navigate } from "react-router-dom";
import { useModuleAvailability } from "../hooks/useModuleAvailability";

/**
 * Direct-URL gate for a module the deployment profile cannot run (Restricted / AirGapped: no
 * internet access). `module` is an egress-catalog module id (e.g. "darkWebMonitoring"). Renders
 * nothing until the flags have loaded, then sends an unavailable module's URL to the dashboard.
 * Innermost guard: role guards around it still apply.
 */
const ModuleRouteGuard = ({ module, children }) => {
  const { loaded, isModuleAvailable } = useModuleAvailability();
  if (!loaded) return null;
  if (!isModuleAvailable(module)) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ModuleRouteGuard;
